import "./paragraph.scss";
import type { ParagraphProps } from "./Paragraph.interface";

/**
 * Primary UI component for user interaction
 */
export function Paragraph(props: ParagraphProps) {
	return (<p id={props.id} aria-label={props.id} className={[props.color, props.className].join(" ")} onClick={props.onClick} title={props.title}>
		{props.text}
	</p>);
}
